export const reduxKey = '@@DAMZ';
export const drawerStreamId = `${reduxKey}:drawer:`;
export const roomStreamIdPrefix = `${reduxKey}:room:`;
export const activityUpdateFrequencyMs = 1000;
export const STREAM_WINDOW_SIZE_DESKTOP = 500;
export const STREAM_WINDOW_SIZE_MOBILE = 200;
export const maximumAttachments = 6;

//# sourceMappingURL=constants.js.map